export const DefaultProduct = (): JSX.Element => <h1>Please Build me Out</h1>;
